import camelCase from 'lodash/camelCase';

export default function createStoreOptions(requireStore, requireStoreFiles, start, parentModule) {
    requireStoreFiles = requireStoreFiles || requireStore.keys();
    start = start || 0;
    parentModule = parentModule || "";

    let storeOptions = {};
    let modules = {};

    while (start < requireStoreFiles.length) {
        const fileName = requireStoreFiles[start];
        const moduleName = fileName.replace(/^\.\//, "").replace(/\.js$/, "");

        if (parentModule && moduleName.indexOf(parentModule) != 0) break;

        const moduleOptions = requireStore(fileName).default;
        let curModuleName = moduleName.substring(parentModule ? parentModule.length : 0);

        if (curModuleName == "index") {
            storeOptions = moduleOptions;
        } else if (curModuleName.indexOf("/") == -1) {
            modules[camelCase(curModuleName)] = moduleOptions;
        } else {
            curModuleName = curModuleName.substring(0, curModuleName.indexOf("/"));
            let storeOptionsData = createStoreOptions(requireStore, requireStoreFiles, start, parentModule + curModuleName + "/");
            modules[camelCase(curModuleName)] = storeOptionsData.storeOptions;
            start = storeOptionsData.start - 1;
        }

        start++;
    }

    if (Object.keys(modules).length > 0) {
        storeOptions.modules = modules;
    }

    return { storeOptions, start };
}